import React from "react";

export const getIcon = (isMultiSelect, isChecked, partiallySelected) => {
    if (isMultiSelect) {
        if (partiallySelected && isChecked) {
            return <SelectDash />;
        }
        return isChecked ? <SelectChecked /> : <SelectUnchecked />;
    } else {
        return isChecked ? <RadioChecked /> : <RadioUnchecked />;
    }
};

export const CloseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="Group_10740"
        data-name="Group 10740"
        viewBox="0 0 16.48 16.48"
    >
        <defs>
            <path id="Line_390" d="M0 0v10.07" data-name="Line 390" />
        </defs>
        <rect
            id="Rectangle"
            width="16.48"
            height="16.48"
            fill="#fff"
            rx="8.24"
        />
        <g
            id="Group_10739"
            fill="none"
            stroke="#18a14a"
            stroke-linecap="round"
            stroke-width="1.5"
            data-name="Group 10739"
            transform="rotate(-45 10.4 3.01)"
        >
            <use
                xlinkHref="#Line_390"
                data-name="Line 390"
                transform="translate(5.04)"
            />
            <use
                xlinkHref="#Line_390"
                id="Line_391"
                data-name="Line 391"
                transform="rotate(90 2.52 7.55)"
            />
        </g>
    </svg>
);

export const SelectChecked = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g
            id="Group_10826"
            data-name="Group 10826"
            transform="translate(-138 -1002)"
        >
            <path
                id="Rectangle_1136"
                fill="#18a14a"
                d="M0 0h20v20H0z"
                data-name="Rectangle 1136"
                transform="translate(138 1002)"
            />
            <path
                id="Icon_ionic-ios-checkbox"
                fill="#fff"
                d="m20.837 10.9-7.792 7.827h-.005a1.053 1.053 0 0 1-.676.321 1.02 1.02 0 0 1-.682-.332l-3.264-3.26a.232.232 0 0 1 0-.332l1.037-1.037a.225.225 0 0 1 .326 0l2.588 2.588 7.11-7.163a.23.23 0 0 1 .163-.07.212.212 0 0 1 .163.07l1.02 1.055a.23.23 0 0 1 .012.333Z"
                data-name="Icon ionic-ios-checkbox"
                transform="translate(133.837 997.512)"
            />
        </g>
    </svg>
);

export const SelectUnchecked = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g
            id="Rectangle_1184"
            fill="#fff"
            stroke="#aaabaf"
            stroke-width="1"
            data-name="Rectangle 1184"
        >
            <path stroke="none" d="M0 0h20v20H0z" />
            <path fill="none" d="M.5.5h19v19H.5z" />
        </g>
    </svg>
);

export const SelectDash = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g
            id="Group_10819"
            data-name="Group 10819"
            transform="translate(-138.441 -1002.308)"
        >
            <path
                id="Rectangle_1136"
                fill="#18a14a"
                d="M0 0h20v20H0z"
                data-name="Rectangle 1136"
                transform="translate(138.441 1002.308)"
            />
            <path
                id="Rectangle_2915"
                fill="#fff"
                d="M0 0h10v2H0z"
                data-name="Rectangle 2915"
                transform="translate(143.441 1011.308)"
            />
        </g>
    </svg>
);

export const RadioChecked = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <g
            id="radio_button_selected"
            data-name="radio button selected"
            transform="translate(-133 -2009)"
        >
            <g
                id="Group_10852"
                data-name="Group 10852"
                transform="translate(0 -416.612)"
            >
                <g
                    id="Rectangle_1194"
                    data-name="Rectangle 1194"
                    transform="translate(133 2425.612)"
                    fill="#fff"
                    stroke="#aaabaf"
                    stroke-width="1"
                >
                    <rect width="20" height="20" rx="10" stroke="none" />
                    <rect
                        x="0.5"
                        y="0.5"
                        width="19"
                        height="19"
                        rx="9.5"
                        fill="none"
                    />
                </g>
                <rect
                    id="Rectangle_1203"
                    data-name="Rectangle 1203"
                    width="12"
                    height="12"
                    rx="6"
                    transform="translate(137 2429.612)"
                    fill="#17a04d"
                />
            </g>
        </g>
    </svg>
);

export const RadioUnchecked = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g
            id="radio_button"
            fill="#fff"
            stroke="#aaabaf"
            stroke-width="1"
            data-name="radio button"
        >
            <rect width="20" height="20" stroke="none" rx="10" />
            <rect width="19" height="19" x=".5" y=".5" fill="none" rx="9.5" />
        </g>
    </svg>
);

export const ToggleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.335 7.554">
        <path
            id="arrow_down"
            fill="#18a14a"
            stroke="#18a14a"
            stroke-width=".5"
            d="M11.945.49a.6363961.6363961 0 0 1 .9.9L7.117 7.118a.636.636 0 0 1-.9 0L.49 1.39a.6363961.6363961 0 0 1 .9-.9l5.277 5.278Z"
            data-name="arrow down"
        />
    </svg>
);

export const CloseIconWhite = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 16.617 16.617"
    >
        <defs>
            <path id="Line_541" d="M0 0h22" data-name="Line 541" />
        </defs>
        <g
            id="Group_11091"
            fill="none"
            stroke="#dedede"
            stroke-width="1.5"
            data-name="Group 11091"
            transform="translate(-16.248 -17.248)"
        >
            <use
                xlinkHref="#Line_541"
                data-name="Line 541"
                transform="rotate(45 -13.0709444 29.1418376)"
            />
            <use
                xlinkHref="#Line_541"
                id="Line_542"
                data-name="Line 542"
                transform="rotate(135 12.4853485 15.5862978)"
            />
        </g>
    </svg>
);
